import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Topbar from "./Navigations/Topbar";
import Footer from "../Footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { fetchAllCustomerProduct } from "../../service/ProductService";
import { fetchProductImage } from "../../service/ProductImageService";
import { useToast } from "../toast/ToastProvider";
import { useSelector } from "react-redux";
import { createCart, getCartProductsByCustomerId } from "../../service/CartService";
import { createWishlist, deleteWishlistById, getWishlistProductsByCustomerId } from "../../service/WishlistService";
import ProductCard from "./Card/ProductCard";
import '../../styles/home.css';

const Home = () => {
  const toast = useToast();
  const authUser = useSelector((state) => state.auth.authUser);
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const [productData, setProductData] = useState([]);

  const isProductInWishlist = (productId) => {
    return wishlist.some(item => item.productId === productId);
  };

  const isProductInCart = (productId, customerId) => {
    return cart.some(
      (item) => item.productId === productId && item.customerId === customerId
    );
  };

  const toggleWishlist = async (productId) => {
    if (!authUser) {
      navigate("/login");
      return;
    }

    try {
      if (isProductInWishlist(productId)) {
        const item = wishlist.find(w => w.productId === productId);
        if (item) {
          await deleteWishlistById(item.wishlistId);
          setWishlist(prev => prev.filter(w => w.productId !== productId));
          toast("Removed from wishlist", "SUCCESS");
        }
      } else {
        await createWishlist({ customerId: authUser.id, productId });
        const updated = await getWishlistProductsByCustomerId(authUser.id);
        setWishlist(updated);
        toast("Added to wishlist", "SUCCESS");
      }
    } catch (error) {
      toast("Failed to update wishlist", "ERROR");
    }
  };

  const addToCart = async (productId) => {
    if (!authUser) {
      navigate("/login");
      return;
    }
    try {
      await createCart({ customerId: authUser.id, productId, quantity: 1 });
      toast("Product added to cart", "SUCCESS");
      const cartData = await getCartProductsByCustomerId(authUser.id);
      setCart(cartData);
    } catch (error) {
      toast("Failed to add product", "ERROR");
    }
  };

  const handleGoToCart = () => {
    navigate("/shopping-cart");
  };

  const fetchCartData = async () => {
    if (authUser?.id) {
      try {
        const cartData = await getCartProductsByCustomerId(authUser.id);
        setCart(cartData);
      } catch (error) {
        console.error("Cart fetch error:", error);
        toast("Failed to load cart", "ERROR");
      }
    }
  };

  const fetchWishlistData = async () => {
    if (authUser?.id) {
      try {
        const data = await getWishlistProductsByCustomerId(authUser.id);
        setWishlist(data || []);
      } catch (error) {
        console.error("Wishlist fetch error:", error);
        toast("Failed to load wishlist", "ERROR");
      }
    }
  };

  const fetchData = async () => {
    try {
      const products = await fetchAllCustomerProduct();
      const images = await fetchProductImage();
      const merged = products?.map(product => {
        const productImages = images?.filter(img => img.productId === product.id);
        return { ...product, images: productImages };
      });
      setProductData(merged);
    } catch (error) {
      toast("Failed to fetch products or images", "ERROR");
    }
  };

  useEffect(() => {
    fetchData();
    fetchCartData();
    fetchWishlistData();
  }, [authUser?.id]);

  const styles = {
    productItem: {
      listStyle: "none",
      marginBottom: "30px",
    },
    productInner: {
      background: "#fff",
      borderRadius: "16px",
      overflow: "hidden",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
      position: "relative",
      height: "100%",
    },
    flash: {
      background: "#c05c2eff",
      color: "#fff",
      fontSize: "12px",
      fontWeight: 600,
      textTransform: "uppercase",
      padding: "4px 10px",
      borderRadius: "12px",
      position: "absolute",
      top: "12px",
      left: "12px",
      zIndex: 2,
    },
    heartBtn: {
      background: "transparent",
      border: "none",
      cursor: "pointer",
      fontSize: "20px",
      position: "absolute",
      top: "12px",
      right: "12px",
      zIndex: 2,
    },
    productThumb: {
      position: "relative",
      textAlign: "center",
      height: "250px",
      overflow: "hidden",
    },
    productImg: {
      width: "100%",
      height: "100%",
      objectFit: "fill",
      transition: "transform 0.3s ease",
    },
    productInfo: {
      padding: "15px",
      textAlign: "center",
    },
    productName: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#222",
      textDecoration: "none",
    },
  };

  return (
    <div className="home">
      <Topbar />

      <div className="main-content">
        <div className="fullwidth-template">
          {/* Carousel */}
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="0"
                className="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>
            <div className="carousel-inner">
              <div className="carousel-item banner-item active">
                <img
                  src="assets/images/Banner/banner1.jpg"
                  className="d-block w-100"
                  alt="..."
                  style={{ height: "60vh", objectFit: "cover" }}
                />
              </div>
              <div className="carousel-item banner-item">
                <img
                  src="assets/images/Banner/banner2.jpg"
                  className="d-block w-100"
                  alt="..."
                  style={{ height: "60vh", objectFit: "cover" }}
                />
              </div>
              <div className="carousel-item banner-item">
                <img
                  src="assets/images/Banner/banner3.png"
                  className="d-block w-100"
                  alt="..."
                  style={{ height: "60vh", objectFit: "cover" }}
                />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>

          {/* Product Tabs */}
          <div className="ysera-tabs default rows-space-40">
            <div className="container">
              <div className="tab-head">
                <ul className="tab-link">
                  <li className="active">
                    <Link
                      data-toggle="tab"
                      to="#bestseller"
                      className="text-decoration-none"
                    >
                      Best Seller
                    </Link>
                  </li>
                  <li>
                    <Link
                      data-toggle="tab"
                      to="#new_arrivals"
                      className="text-decoration-none"
                    >
                      New Arrivals
                    </Link>
                  </li>
                  <li>
                    <Link
                      data-toggle="tab"
                      to="#top-rated"
                      className="text-decoration-none"
                    >
                      Top Rated
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="tab-container">
                {["bestseller", "new_arrivals", "top-rated"].map((tab) => (
                  <div
                    key={tab}
                    id={tab}
                    className={`tab-panel ${tab === "bestseller" ? "active" : ""
                      }`}
                  >
                    <div className="ysera-product">
                      <ul className="row list-products auto-clear equal-container product-grid">
                        {productData?.map((data, index) => {
                          const inCart = isProductInCart(data.id, authUser?.id);
                          const inWishlist = isProductInWishlist(data.id);
                          return (
                            <ProductCard
                              key={index}
                              data={data}
                              styles={styles}
                              inWishlist={inWishlist}
                              inCart={inCart}
                              onToggleWishlist={toggleWishlist}
                              onAddToCart={addToCart}
                              onGoToCart={handleGoToCart}
                            />
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="banner-wrapp rows-space-30">
            <div className="container">
              <div className="row">
                {/* Left Banner */}
                <div className="col-lg-5 col-md-5 col-sm-12 mt-2">
                  <div className="banner">
                    <div
                      className="card bg-dark text-white"
                      style={{ height: "22rem" }}
                    >
                      <img
                        src="assets/images/Banner/banner1.jpg"
                        className="card-img"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        alt="Royal Necklace"
                      />
                      <div
                        className="card-img-overlay d-flex flex-column justify-content-center align-items-start"
                        style={{
                          background: "rgba(0,0,0,0.4)",
                          padding: "20px",
                          borderRadius: "8px",
                        }}
                      >
                        <h3
                          className="card-title fw-bold"
                          style={{ fontSize: "1.8rem" }}
                        >
                          Royal Heritage Necklaces
                        </h3>
                        <p className="card-text" style={{ fontSize: "1rem" }}>
                          Discover the timeless elegance of handcrafted
                          necklaces, inspired by royal traditions and designed
                          for modern grace.
                        </p>
                        <p className="card-text">
                          <small className="text-warning fw-semibold">
                            Unveil Your Royal Charm
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Banner */}
                <div className="col-lg-7 col-md-7 col-sm-12 mt-2">
                  <div className="banner">
                    <div
                      className="card bg-dark text-white"
                      style={{ height: "22rem" }}
                    >
                      <img
                        src="assets/images/Banner/banner2.jpg"
                        className="card-img"
                        alt="Elegant Necklace"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="card-img-overlay d-flex flex-column justify-content-center align-items-start"
                        style={{
                          background: "rgba(0,0,0,0.4)",
                          padding: "20px",
                          borderRadius: "8px",
                        }}
                      >
                        <h3
                          className="card-title fw-bold"
                          style={{ fontSize: "1.8rem" }}
                        >
                          Elegance Beyond Time
                        </h3>
                        <p className="card-text" style={{ fontSize: "1rem" }}>
                          Adorn yourself with necklaces that blend royal
                          artistry with modern sophistication, perfect for every
                          grand occasion.
                        </p>
                        <p className="card-text">
                          <small className="text-warning fw-semibold">
                            Luxury Crafted for You
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Mobile Footer */}
      <div className="footer-device-mobile">
        <div className="wapper">
          <div className="footer-device-mobile-item device-home">
            <Link to="/" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-house"></i>
              </span>{" "}
              Home
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/wishlist" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-heart"></i>
                <span className="count-icon">{wishlist.length}</span>
              </span>{" "}
              Wishlist
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/shopping-cart" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-shopping-cart-simple" />
                <span className="count-icon">{cart.length}</span>
              </span>{" "}
              Cart
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-user">
            <Link to="/profile" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-user"></i>
              </span>{" "}
              Account
            </Link>
          </div>
        </div>
      </div>

      {/* WhatsApp Button */}
      <Link
        to="https://api.whatsapp.com/send?phone=919865212131&text=Hi!%20I%20need%20assistance"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div
          style={{
            position: "fixed",
            bottom: "19vh",
            right: "1.5vw",
            width: "clamp(40px, 6vw, 60px)",
            height: "clamp(40px, 6vw, 60px)",
            backgroundColor: "#25D366",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
            cursor: "pointer",
            zIndex: 1000,
            transition: "transform 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >

          <i class="ph ph-whatsapp-logo" style={{
            fontSize: "clamp(20px, 4vw, 35px)",
            color: "white",
          }}></i>

        </div>
      </Link>
      <Link to="#" className="backtotop">
        <i
          className="ph ph-caret-double-up"
          style={{
            color: "white",
            fontSize: "30px",
          }}
        ></i>
      </Link>

    </div>
  );
};

export default Home;